/**
 * メール連携 OAuth コールバック中継ページ.
 *
 * Amplify Auth が URL の ?code= を Cognito OAuth と誤認するため、
 * このページは認証フロー (AuthRedirect) の外に配置する。
 * code/state を sessionStorage に退避し、/profile?tab=integrations に
 * 完全なページ遷移で戻す。実 API 呼び出しは EmailIntegrationsTab が行う。
 */

import { Button } from "components/ui/Button";
import { Loading } from "components/ui/Loading/Loading";
import type React from "react";
import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const EmailOAuthCallbackPage: React.FC = () => {
  const { provider = "" } = useParams<{ provider: string }>();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code || !state) {
      const oauthError = searchParams.get("error");
      if (oauthError === "access_denied") {
        // ユーザーがキャンセル: 設定画面に戻す
        window.location.href = "/profile?tab=integrations";
        return;
      }
      setError("認可情報が不足しています。もう一度お試しください。");
      return;
    }

    sessionStorage.setItem("emailOauthCode", code);
    sessionStorage.setItem("emailOauthState", state);
    sessionStorage.setItem("emailOauthProvider", provider);

    // window.location.href で完全なページ遷移 (Amplify の code 誤認を回避)
    window.location.href = "/profile?tab=integrations";
  }, [searchParams, provider]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
        <div className="alert alert-error max-w-md">
          <span>{error}</span>
        </div>
        <Button asChild variant="ghost" size="sm">
          <a href="/profile?tab=integrations">メール連携設定に戻る</a>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
      <Loading size="lg" />
      <p className="text-base-content/60">メール連携を処理中...</p>
    </div>
  );
};

export default EmailOAuthCallbackPage;
